(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bam-finder"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('bam-vehicle-finder')) {
 customElements.define('bam-vehicle-finder',class extends HTMLElement {
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   const data=JSON.parse(this.querySelector('script[type="application/json"]').textContent);
   const year=this.querySelector('[data-year]'),make=this.querySelector('[data-make-select]'),model=this.querySelector('[data-model-select]'),form=this.querySelector('form'),button=form.querySelector('[type="submit"]'),status=this.querySelector('[data-status]');
   const fill=(select,values)=>{select.replaceChildren(new Option(this.dataset.choose,''));for(const value of values)select.add(new Option(value,value));};
   fill(year,Object.keys(data).sort().reverse());
   year.addEventListener('change',()=>{fill(make,year.value?Object.keys(data[year.value]).sort():[]);fill(model,[]);make.disabled=!year.value;model.disabled=true;button.disabled=true;status.textContent=year.value?this.dataset.make:this.dataset.start;});
   make.addEventListener('change',()=>{fill(model,make.value?Object.keys(data[year.value][make.value]).sort():[]);model.disabled=!make.value;button.disabled=true;status.textContent=make.value?this.dataset.model:this.dataset.make;});
   model.addEventListener('change',()=>{button.disabled=!model.value;status.textContent=model.value?this.dataset.ready:this.dataset.model;});
   form.addEventListener('reset',()=>{fill(make,[]);fill(model,[]);make.disabled=true;model.disabled=true;button.disabled=true;status.textContent=this.dataset.start;});
   form.addEventListener('submit',event=>{event.preventDefault();const tag=data[year.value]?.[make.value]?.[model.value];if(!tag)return;window.location.assign(this.dataset.collection+'/'+encodeURIComponent(tag));});
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bam-product-guide"]) return;
  try {
    
if (!customElements.get('bam-product-tabs')) {
  customElements.define('bam-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = [...this.querySelectorAll('[data-panel]')];
      const select = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        panels[index].setAttribute('role', 'tabpanel');
        panels[index].setAttribute('aria-labelledby', tab.id);
        panels[index].tabIndex = 0;
        tab.addEventListener('click', () => select(index));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
      });
      this.querySelector('[role="tablist"]').hidden = false;
      select(0);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
